export enum CUSTOMER_SURVEYS_TAB {
  Surveys = "surveys",
  CompanyData = "companyData",
  CanopyLibrary = "canopyLibrary",
  SoftwareReviewLinks = "softwareReviewLinks"
}

export enum CUSTOMER_INSIGHT_ANSWER_STATUS {
  Pending = "Pending",
  InReview = "InReview",
  Approved = "Approved",
  Rejected = "Rejected",
  Declined = "Declined",
  Outdated = "Outdated"
}

export enum ReviewStatusGroup {
  Incomplete = "incomplete",
  Sent = "sent",
  Validated = "validated",
  Rejected = "rejected"
}

export enum CUSTOMER_PERSONA {
  User = "User",
  Influencer = "Influencer"
}

export enum CUSTOMER_IMPLEMENTATION_STAGE {
  Pilot = "Pilot",
  LessThan1Year = "LessThan1Year",
  MoreThan1Year = "MoreThan1Year",
  OffBoarding = "OffBoarding",
  NotSure = "NotSure"
}

export enum CUSTOMER_RENEWAL_INTENT {
  Yes = "Yes",
  No = "No",
  NotSure = "NotSure"
}

export enum CUSTOMER_SPEND_QUESTION {
  Yes = "Yes",
  No = "No"
}

export enum CUSTOMER_SPEND_RANGE {
  UpTo10k = "UpTo10k",
  Between10kAnd20k = "Between10kAnd20k",
  Between20kAnd50k = "Between20kAnd50k",
  Between50kAnd100k = "Between50kAnd100k",
  MoreThan100k = "MoreThan100k"
}

export enum CUSTOMER_FIELD_NAMES {
  PERSONA = "persona",
  PERSONA_DETAILS = "personaDetails",
  IMPLEMENTATION_STAGE = "implementationStage",
  SPEND_QUESTION = "spendQuestion",
  SPEND = "spend",
  SPEND_DETAILS = "spendDetails",
  NPS = "nps",
  NPS_DETAILS = "npsDetails",
  RENEWAL_INTENT = "renewalIntent",
  RENEWAL_DETAILS = "renewalDetails",
  COMPETITORS = "competitors",
  OTHER_COMMENTS = "otherComments",
  PURCHASE_DETAILS = "purchaseDetails",
  USAGE_DETAILS = "usageDetails"
}

export enum QUALITATIVE_QUESTION_KEY {
  BuyingProcess = "buyingProcess",
  SpendBreakdown = "spendBreakdown",
  RelyReasons = "relyReasons",
  SwitchFactors = "switchFactors",
  NpsJustification = "npsJustification"
}

export enum DECLINE_INSIGHT_RESPONSE_TYPE {
  SUCCESS = "Success",
  EXPERT_NOT_FOUND = "ExpertNotFound",
  ALREADY_DECLINED = "AlreadyDeclined"
}

export enum CLIENT_SOFTWARE_REVIEW_RESOLVE_STATUS {
  AlreadyRewarded = "AlreadyRewarded",
  AlreadyReviewed = "AlreadyReviewed",
  Eligible = "Eligible"
}

export enum SOFTWARE_REVIEW_START_STEP {
  Quantitative = "Quantitative",
  Qualitative = "Qualitative"
}

export enum ReviewSource {
  AI = "ai",
  Suggestion = "suggestion",
  Manual = "manual",
  ProjectAIScreening = "project_ai_screening"
}

export enum ReviewEntryPoint {
  Onboarding = "onboarding",
  ProjectApplication = "project_application",
  ProfileEdit = "profile_edit"
}

export enum SuggestionType {
  Hot = "hot",
  Regular = "regular"
}

export enum PrefetchStatus {
  Idle = "idle",
  Loading = "loading",
  Success = "success",
  Error = "error"
}

export enum SPEND_RANGE_VALUE {
  UpTo10k = 10000,
  Between10kAnd20k = 20000,
  Between20kAnd50k = 50000,
  Between50kAnd100k = 100000,
  MoreThan100k = 1000000
}

export enum CONNECT_MODE {
  EXISTING = "existing",
  NEW = "new"
}

export enum EXPERT_CONNECT_SOURCE {
  CustomerSignals = "customer_signals",
  CustomerReportSegment = "customer_report_segment"
}

export enum EXPERT_CONNECT_FAILURE_REASON {
  MissingClient = "missing_client",
  MissingDefaultAngle = "missing_default_angle",
  AllAssignmentsFailed = "all_assignments_failed",
  Exception = "exception",
  WebhookFailed = "webhook_failed"
}

export enum SIGNALS_ENGAGEMENT_CTA_VARIANT {
  AccessFullProfile = "access_full_profile",
  RequestTrial = "request_trial",
  TalkToSales = "talk_to_sales"
}

export enum SoftwareExperiencePanelEnum {
  SuggestedForYou = "suggestedForYou",
  Outdated = "outdated",
  ToUpgrade = "toUpgrade",
  YourReviews = "yourReviews",
  NotUsingAnymore = "notUsingAnymore",
  HowToGetMoreRewards = "howToGetMoreRewards"
}

export enum SoftwareExperienceLayoutVariant {
  Mobile = "mobile",
  Desktop = "desktop"
}

export enum ExpertExperienceAddReviewDrawerSource {
  HeaderButton = "header_button",
  SuggestedCompany = "suggested_company",
  CantFindTool = "cant_find_tool",
  OutdatedUpdate = "outdated_update",
  OutdatedEmptyState = "outdated_empty_state",
  Upgrade = "upgrade",
  TipFooter = "tip_footer",
  WorkHistoryLink = "work_history_link",
  LegacyRedirectParam = "legacy_redirect_param",
  PreselectedCompanyParam = "preselected_company_param",
  NotUsingAnymoreReactivate = "not_using_anymore_reactivate"
}

export enum ExpertExperienceReviewAction {
  YourReviewViewed = "your_review_viewed",
  UpgradeClicked = "upgrade_clicked",
  OutdatedUpdateClicked = "outdated_update_clicked",
  OutdatedNoChangesClicked = "outdated_no_changes_clicked",
  OutdatedNoChangesSubmitted = "outdated_no_changes_submitted",
  OutdatedStillUsingSelected = "outdated_still_using_selected",
  OutdatedNotUsingSelected = "outdated_not_using_selected",
  ReviewDetailsNotUsingSelected = "review_details_not_using_selected",
  NotUsedSubmitted = "not_used_submitted",
  NotUsingAnymoreReactivateClicked = "not_using_anymore_reactivate_clicked",
  EditReviewClicked = "edit_review_clicked"
}

export enum ExpertExperienceWorkHistoryAction {
  PositionAdded = "position_added",
  PositionUpdated = "position_updated",
  PositionDeleted = "position_deleted"
}

export enum ExpertExperiencePanelChangeSource {
  Sidebar = "sidebar",
  Collapse = "collapse",
  DeepLink = "deep_link"
}
